// Shared helpers for the Community section.

export const FORUM_ACCENTS = {
  "general-soccer": "#16a34a",
  "transfers-rumors": "#f59e0b",
  "matches-results": "#2563eb",
  "players": "#db2777",
  "clubs-teams": "#7c3aed",
  "leagues-competitions": "#0891b2",
  "tactics-analysis": "#dc2626",
  "soccer-culture": "#ca8a04",
  "off-topic": "#64748b",
  "site-feedback": "#0f766e",
};

export const LEVEL_STYLES = {
  Rookie: "bg-slate-100 text-slate-600",
  Starter: "bg-emerald-100 text-emerald-700",
  Regular: "bg-sky-100 text-sky-700",
  Pro: "bg-violet-100 text-violet-700",
  Veteran: "bg-amber-100 text-amber-800",
  Legend: "bg-ink text-volt",
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

export const initialOf = (name) => (name || "?").trim().slice(0, 1).toUpperCase();
